import { asyncPipe } from '@helo/utils'
import { StateCreator } from 'zustand'

import { NotificationItemResponse } from '../../../components/Notifications/NotificationsMenu'
import {
  markAllNotificationsAsRead,
  markNotificationAsRead,
} from '../../../services/NotificationService'
import {
  ColumnState,
  TableColumnConfig,
} from '../../../widgets/TableWidget/tablewidget.parts'
import { NotificationSliceActions } from './notificationSlice.actions'

export type NotificationsState = {
  downloadHandler: (fileId: string, fileName: string) => void
  markAllAsRead: () => void
  markErrorsAsRead: () => void
  notifications: NotificationItemResponse[]
  pollingCount: number
  pollingSpeed: 'fast' | 'slow'
  fetchNotifications: () => void
  startPolling(): void
  requestQueryExport: (options: {
    queryDefinitionId?: string
    fileName?: string
    variables?: Record<string, any>
    columns?: ColumnState[]
    columnConfigs?: TableColumnConfig[]
    connectionLocator?: any // TODO: Define proper type for connection locator
  }) => Promise<void>
  handlePollingInterval: () => void
}

export type NotificationsSlice = {
  notifications: NotificationsState
}

export const notificationsSlice: StateCreator<
  NotificationsSlice,
  [],
  [],
  NotificationsSlice
> = (set, get) => ({
  notifications: {
    notifications: [],
    pollingCount: 0,
    pollingSpeed: 'slow',

    fetchNotifications: () =>
      asyncPipe(get(), NotificationSliceActions.getNotifications(), store =>
        set(store),
      ),
    handlePollingInterval: () => {
      asyncPipe(
        get(),
        // TODO: handle difference between fast and short polling.
        NotificationSliceActions.handlePollingInterval(),
        store => set(store),
      )
    },
    startPolling: () =>
      asyncPipe(get(), NotificationSliceActions.startPolling('slow'), store =>
        set(store),
      ),
    markErrorsAsRead: async () => {
      const unreadErrorNotifications = get().notifications.notifications.filter(
        notification =>
          notification.category === 'ERROR' && !notification.isRead,
      )

      if (unreadErrorNotifications.length === 0) {
        return
      }

      await Promise.all(
        unreadErrorNotifications.map(notification => {
          return markNotificationAsRead(notification.id)
        }),
      )

      await get().notifications.fetchNotifications()
    },
    markAllAsRead: async () => {
      await markAllNotificationsAsRead()
      get().notifications.fetchNotifications()
    },

    downloadHandler: (fileId: string, fileName: string) =>
      asyncPipe(
        get(),
        NotificationSliceActions.downloadHandler(fileId, fileName),
        store => set(store),
      ),
    requestQueryExport: options =>
      asyncPipe(
        get(),
        NotificationSliceActions.requestQueryExport(options),
        store => set(store),
      ),
  },
})
